import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import dlsStyles from '../../styles/dls.css';
import styles from '../TravelHeader.scss';
import { useIsLoggedIn, useNavigationLinksHook } from '../../apiHooks/apiHooks';
import ProfileDrawerTitleSection from '../ProfileDrawer/ProfileDrawerTitleSection';
import desktopStyles from './Desktop.scss';
import { useGetMRPointsBalance, useIsCenturion, useTopCard } from '../../apiHooks/membershipHooks';
import { appendQueryToUrl } from '../../utils/navigationUtils';
import ColumnContent from '../ColumnContent/ColumnContent';

const Desktop = () => {
  const { data: navigationLinks } = useNavigationLinksHook();
  const { data: isLoggedIn } = useIsLoggedIn();
  const topCard = useTopCard();
  const { formatMessage } = useIntl();
  const isCenturion = useIsCenturion();
  const MRPoints = useGetMRPointsBalance();
  return (
    <div className={`desktop ${dlsStyles.body} ${dlsStyles['hidden-md-down']}`} data-testid="desktopNav">
      <div className={`${isCenturion ? dlsStyles['dls-black-bg'] : dlsStyles['dls-bright-blue-bg']} ${dlsStyles['dls-white']}`}>
        <nav className={`${dlsStyles.container} ${dlsStyles.flex} ${dlsStyles['flex-row']}}`}>
          <a href={navigationLinks?.generalLinks.atoLink} className={clsx(dlsStyles.flex, dlsStyles['margin-r'], styles.focusLink)}>
            <img
                // @ts-expect-error -- fetch priority exists
              fetchPriority="high"
              src={navigationLinks?.generalLinks.travelLogoDesktopSrcUrl}
              alt={formatMessage({ id: 'amexTravel.logo.altText' })}
            />
          </a>
          <div
            className={`${isCenturion ? dlsStyles['dls-black-bg'] : dlsStyles['dls-bright-blue-bg']} ${dlsStyles.nav} ${dlsStyles['nav-horizontal']} nav-chevron ${styles.navBlueBar}`}
          >
            <ul className={dlsStyles['margin-l']}>
              {navigationLinks?.mainNavigation && navigationLinks.mainNavigation.map((menuItem) => (
                <li className={`${dlsStyles['nav-item']} ${dlsStyles['margin-r']} ${dlsStyles['position-relative']}`} key={menuItem.key}>
                  {menuItem.url ? (
                    <a href={appendQueryToUrl(menuItem.url, menuItem.linknav)} className={`${dlsStyles.caret} ${dlsStyles['dls-white']} ${styles.focusLink}`}>
                      {menuItem.label}
                    </a>
                  ) : (
                    <button
                      type="button"
                      className={`${dlsStyles['nav-link']} ${dlsStyles.caret} ${dlsStyles['dls-white']} ${styles.focusLink}`}
                      aria-current="false"
                      aria-expanded="false"
                      aria-haspopup="listbox"
                    >
                      {menuItem.label}
                    </button>
                  )}
                  {menuItem.columns.length > 0 && (
                    <ColumnContent menuItem={menuItem} />
                  )}
                </li>
              ))}
              <li className={`${dlsStyles['nav-item']} ${desktopStyles.profileDrawerWrapper} ${dlsStyles.flex}`}>
                <button
                  type="button"
                  id="profile-drawer-button"
                  className={`${dlsStyles['nav-link']} ${dlsStyles.caret} ${dlsStyles['dls-white']} ${styles.focusLink}`}
                  aria-current="false"
                  aria-expanded="false"
                  aria-haspopup="listbox"
                >
                  {
                    isLoggedIn && navigationLinks?.features.travelerGreeting === 'true' && topCard ? (
                      <div className={clsx(dlsStyles.flex, dlsStyles['flex-row'], dlsStyles['flex-align-center'])}>
                        { !isCenturion && (
                          <img
                            src={topCard.demographics.product.cardArtCdnLink}
                            alt={topCard.demographics.product.description}
                            className={clsx(dlsStyles['pad-1-r'], styles.cardArt)}
                          />
                        )}
                        <p className={`${dlsStyles.flex} ${dlsStyles['text-wrap']}`}>
                          {formatMessage({ id: 'hi' }, { name: topCard.demographics.firstName })} {MRPoints && ` | ${MRPoints} ${formatMessage({ id: 'pts' })}`}
                        </p>
                      </div>
                    ) : <div>{formatMessage({ id: 'welcome.traveller' })}</div>
                  }
                </button>
                <div
                  id="profile-drawer-dropdown"
                  className={`${dlsStyles['flex-column']} ${desktopStyles.profileDrawer} ${dlsStyles['pad-0']}`}
                  style={{ display: 'none' }}
                >
                  <div id="overflow-container">
                    <ProfileDrawerTitleSection />
                    <div className={`${dlsStyles['nav-vertical']} nav-chevron ${dlsStyles['width-full']} ${styles.profileLinks}`}>
                      <ul className={`${dlsStyles['margin-0']}  ${dlsStyles.flex} ${dlsStyles['flex-column']}`}>
                        {navigationLinks?.profileDrawer && navigationLinks.profileDrawer.map(
                          (menuItem) => (
                            <li className={`${dlsStyles['nav-item']}`} key={menuItem.label}>
                              <a href={appendQueryToUrl(menuItem.url, menuItem.linknav)} target="_blank" className={`${dlsStyles['nav-link']}`} rel="noreferrer">
                                {menuItem.label}
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      { isLoggedIn && <input style={{ display: 'none' }} id="logged-in" /> }
    </div>
  );
};

export default Desktop;
